import React from 'react';
import commingSoonImage from "../../assets/coming-soon.svg";

const CrowdFunding = () => {
  return (
    <div>
      <div className="mx-auto px-5 xl:px-7 py-6 bg-white h-[calc(100vh-135px)]  ">
          <div className="flex flex-col items-center justify-center gap-2">
            <figure className="max-w-[100%] w-full md:max-w-[360px]">
              <img src={commingSoonImage} alt="coming soon" className="w-full" />
            </figure>
            <h1 className="text-[32px] md:text-[32px] font-medium text-[#f36120]">Crowd Funding</h1>
            <p className="text-md font-medium text-[#777B7F] mt-1">
              This feature is currently unavailable.
            </p>
          </div>
        </div>
    </div>
  )
}

export default CrowdFunding
